module.exports = "/images/vendor/flag-icon-css/flags/4x3/cw.svg?f1b3043c88d52ecf9222b5987791bbac";